const translations = {
  en: {
    // Navigation
    home: "Home",
    ourServices: "Our Services",
    contact: "Contact",
    
    // Home page
    heroTitle: "Advanced Medical Testing Solutions",
    heroSubtitle: "Providing accurate and reliable laboratory testing services",
    exploreServices: "Explore Our Services",
    
    // Services section
    servicesTitle: "Our Services",
    coreLab: "Core Laboratory",
    coreLabDesc: "Comprehensive testing including chemistry, hematology, immunology, and more",
    molecularTesting: "Molecular Testing",
    molecularTestingDesc: "Advanced diagnostic testing for COVID-19, Flu A/B, and RSV",
    
    // Reagents section
    reagentsTitle: "Reagents and Collection Kits",
    reagentsDesc: "High-quality reagents trusted by researchers, clinicians, and diagnostic labs. Designed to maintain integrity throughout analytical processes.",
    reagentsCallToAction: "Explore how our solutions support your workflow with confidence.",
    
    // Expanded Reagents section for Services page
    expandedReagentsTitle: "Reagents and<br />Collection Kits",
    expandedReagentsDesc: "Accurate testing starts with reliable reagents—and NuWav Labs is proud to support that critical first step. As a trusted reseller, we provide a curated selection of reagents used across clinical, environmental, and research applications.",
    expandedReagentsOffers: "We now offer:",
    reagentsOffer1: "Clinical diagnostic reagents",
    reagentsOffer2: "Research-grade laboratory reagents",
    reagentsOffer3: "Environmental testing solutions",
    reagentsOffer4: "Specialized analytical reagents",
    reagentsFooter: "Backed by our commitment to quality and service, our reagent line gives your team the confidence to focus on results—not logistics.",
    
    // Additional Home Content
    homeContent1: "We leverage cutting-edge automation and rigorous quality management to deliver fast, reliable diagnostic and analytical services.",
    homeContent2: "Our streamlined workflows handle everything from routine blood analyses to complex molecular testing, ensuring consistent accuracy and high throughput without sacrificing attention to detail.",
    homeContent3: "Backed by a team of experienced scientists and state of the art processes, we offer tailored solutions for research, clinical trials and development projects. Partner with us for expert support, transparent reporting and rapid turnaround that keeps your work moving forward.",
    
    // Services Page
    servicesPageTitle: "Advanced Clinical & Molecular Diagnostics",
    servicesPageDesc: "Our high-throughput clinical lab offers a wide range of testing services with precision, scalability, and speed. Using sophisticated, compliant systems, we provide dependable diagnostics to healthcare providers, research groups, and organizations requiring routine or advanced molecular testing.",
    coreTestingServices: "Core Testing Services",
    molecularTestingServices: "Molecular Testing Services",
    molecularTestingDesc: "Our molecular diagnostics division is equipped for high-volume nucleic acid testing, delivering fast, accurate results for respiratory infections, including:",
    expandableCapabilities: "Expandable Capabilities",
    expandableCapabilitiesDesc: "Thanks to the versatility and automation of our lab systems, we can rapidly configure new testing protocols to meet your organization's specific needs. Based on our equipment, we are capable of expanding into:",
    molecularPCR: "Molecular & PCR-Based Diagnostics",
    clinicalChemistry: "Clinical Chemistry & Immunoassay",
    hematology: "Hematology & Blood Smear Analysis",
    
    // Core Testing Services Items
    generalImmunology: "General Immunology",
    generalImmunologyDesc: "Allergy and autoimmune testing",
    routineChemistry: "Routine Chemistry",
    routineChemistryDesc: "Comprehensive metabolic, renal, and hepatic panels",
    routineHematology: "Routine Hematology",
    routineHematologyDesc: "Blood cell counts, anemia profiling",
    urinalysis: "Urinalysis",
    urinalysisDesc: "Urine chemistry, sediment microscopy",
    virology: "Virology",
    virologyDesc: "Viral antibodies, common infectious markers",
    
    // Molecular Testing Items
    covid19: "COVID-19 (SARS-CoV-2)",
    covid19Desc: "Rapid and accurate detection",
    influenza: "Influenza A/B",
    influenzaDesc: "Seasonal flu testing",
    rsv: "RSV",
    rsvDesc: "Respiratory syncytial virus detection",
    
    // Molecular PCR Items
    multiplexRespiratory: "Multiplex respiratory pathogen panels",
    gastrointestinalPathogen: "Gastrointestinal pathogen detection",
    stiUtiTesting: "STI and UTI testing using real-time PCR",
    
    // Clinical Chemistry Items
    cardiacBiomarkers: "Cardiac biomarkers (troponin, CK-MB, BNP)",
    fertilityHormone: "Fertility and reproductive hormone testing",
    vitaminPanels: "Vitamin D, thyroid, and adrenal panels",
    infectiousSerology: "Infectious disease serology",
    tumorMarkers: "Tumor markers and metabolic syndrome indicators",
    
    // Hematology Items
    cellMorphology: "Cell morphology reviews with high-resolution staining",
    differentialWBC: "Differential WBC counts with flagging",
    reticulocyte: "Reticulocyte and immature cell fraction analysis",
    hematologicDisorders: "Screening for hematologic disorders",
    
    whyChooseUs: "Why Choose Us",
    fullyCompliant: "Fully Compliant",
    fullyCompliantDesc: "All operations align with CLIA and federal regulations",
    scalableThroughput: "Scalable Throughput",
    scalableThroughputDesc: "High-volume testing with quick turnaround",
    flexibleProtocols: "Flexible Protocols",
    flexibleProtocolsDesc: "Custom test development available for research or clinical applications",
    partnerDriven: "Partner-Driven Approach",
    partnerDrivenDesc: "Collaborative design of testing programs to suit your exact needs",
    readyToExpand: "Ready to Expand Your Testing?",
    readyToExpandDesc: "If your organization is seeking a partner lab with the ability to scale and adapt—whether for routine testing or specialized panels—we're ready to configure our systems for your goals.",
    
    // Contact Page
    contactUs: "Contact Us",
    getInTouch: "Get in touch with our team",
    sendMessage: "Send us a message",
    address: "Address",
    phone: "Phone",
    name: "Name",
    email: "Email",
    message: "Message",
    submit: "Submit",
    formSubmissionMessage: "Thank you for your message. We will get back to you soon!",
    
    // Certifications
    certifications: "Certifications",
    hipaaCompliant: "HIPAA Compliant",
    capAccredited: "COLA Accredited",
    cliaCertified: "CLIA Certified",
    privacyShield: "Privacy Shield Compliant",
    
    // Location & Contact
    location: "Location",
    
    // Legal
    legal: "Legal",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    allRightsReserved: "All rights reserved.",
    
    // Privacy Policy Page
    privacyIntro: "Introduction",
    privacyIntroText: "NuWav Laboratories (\"we,\" \"our,\" or \"us\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you interact with our services.",
    infoWeCollect: "Information We Collect",
    personalHealthInfo: "Personal Health Information",
    personalHealthInfoText: "As a HIPAA-compliant laboratory, we collect and process personal health information including:",
    patientDemographic: "Patient demographic information",
    medicalHistory: "Medical history and conditions",
    labResults: "Laboratory test results",
    insuranceInfo: "Insurance and billing information",
    otherHealthInfo: "Other health-related information necessary for testing services",
    howWeUseInfo: "How We Use Your Information",
    useInfoText: "We use the collected information for:",
    providingLabServices: "Providing laboratory testing services",
    processingResults: "Processing and delivering test results",
    billingPayment: "Billing and payment processing",
    communicatingTests: "Communicating about your tests and results",
    qualityAssurance: "Quality assurance and improvement",
    complianceRequirements: "Compliance with legal and regulatory requirements",
    dataProtection: "Data Protection",
    dataProtectionText: "We implement appropriate technical and organizational security measures to protect your information, including:",
    encryption: "Encryption of data in transit and at rest",
    accessControls: "Access controls and authentication measures",
    securityAssessments: "Regular security assessments and audits",
    staffTraining: "Staff training on privacy and security procedures",
    physicalSecurity: "Physical security measures at our facilities",
    hipaaCompliance: "HIPAA Compliance",
    hipaaComplianceText: "As a covered entity under HIPAA, we maintain compliance with all applicable requirements, including:",
    maintainingPrivacy: "Maintaining privacy of protected health information",
    providingAccess: "Providing access to your health information upon request",
    obtainingAuth: "Obtaining appropriate authorizations for disclosure",
    accountingDisclosures: "Maintaining an accounting of disclosures",
    privacyPractices: "Providing notice of privacy practices",
    yourRights: "Your Rights",
    yourRightsText: "Under HIPAA and other applicable laws, you have certain rights regarding your health information:",
    rightToAccess: "Right to access your health information",
    rightToCorrections: "Right to request corrections to your information",
    rightToAccounting: "Right to receive an accounting of disclosures",
    rightToRestrictions: "Right to request restrictions on use and disclosure",
    rightToConfidential: "Right to receive confidential communications",
    rightToNotice: "Right to receive notice of privacy practices",
    contactInfo: "Contact Information",
    contactInfoText: "For questions about this Privacy Policy or to exercise your rights, please contact our Privacy Officer at our office:",
    updatesToPolicy: "Updates to This Policy",
    updatesToPolicyText: "We may update this Privacy Policy from time to time. The updated version will be indicated by an updated \"Last Updated\" date and the updated version will be effective as soon as it is accessible.",
    lastUpdated: "Last Updated: April 16, 2025",
    
    // Terms of Service Page
    agreementToTerms: "Agreement to Terms",
    agreementToTermsText: "These Terms of Service constitute a legally binding agreement made between you and NuWav Laboratories (\"we,\" \"us,\" or \"our\") concerning your use of our laboratory services and website.",
    servicesDescription: "Services Description",
    servicesDescriptionText: "NuWav Laboratories provides clinical laboratory testing services, including but not limited to:",
    coreLabTesting: "Core laboratory testing services",
    molecularDiagnostic: "Molecular diagnostic testing",
    clinicalChemistryAnalysis: "Clinical chemistry analysis",
    diagnosticProcedures: "Diagnostic laboratory procedures",
    resultsReporting: "Results reporting and interpretation",
    professionalStandards: "Professional Standards",
    professionalStandardsText: "We maintain the highest professional standards and comply with all applicable regulations, including:",
    hipaaComplianceStandard: "HIPAA compliance for patient privacy",
    capAccreditationStandards: "CAP accreditation standards",
    cliaCertificationRequirements: "CLIA certification requirements",
    privacyShieldFramework: "Privacy Shield framework principles",
    stateRegulations: "State and federal laboratory regulations",
    userResponsibilities: "User Responsibilities",
    userResponsibilitiesText: "By using our services, you agree to:",
    provideAccurateInfo: "Provide accurate and complete information",
    maintainConfidentiality: "Maintain the confidentiality of any account credentials",
    complyWithLaws: "Comply with all applicable laws and regulations",
    useLegitimateServices: "Use services only for legitimate medical purposes",
    respectIntellectualProperty: "Respect intellectual property rights",
    sampleRequirements: "Sample Requirements",
    sampleRequirementsText: "All submitted samples must:",
    meetCollectionRequirements: "Meet specified collection requirements",
    properlyLabeled: "Be properly labeled and identified",
    properlyPackaged: "Be packaged according to safety guidelines",
    includeRequisition: "Include complete requisition information",
    submitTimeframes: "Be submitted within acceptable timeframes",
    resultsAndReports: "Results and Reports",
    resultsAndReportsText: "Regarding test results and reports:",
    resultsProvidedTo: "Results are provided only to authorized recipients",
    turnaroundTimes: "Turnaround times are estimates and not guarantees",
    criticalValues: "Critical values are reported according to protocol",
    resultsRequireCorrelation: "Results may require clinical correlation",
    reportsRetention: "Reports are maintained according to retention policies",
    limitationOfLiability: "Limitation of Liability",
    limitationOfLiabilityText: "To the maximum extent permitted by law, NuWav Laboratories shall not be liable for:",
    indirectDamages: "Indirect or consequential damages",
    serviceDelays: "Delays in service delivery",
    improperSampleCollection: "Issues arising from improper sample collection",
    thirdPartyInterpretation: "Results interpretation by third parties",
    beyondControl: "Circumstances beyond reasonable control",
    changesToTerms: "Changes to Terms",
    changesToTermsText: "We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Continued use of our services constitutes acceptance of modified terms."
  },
  es: {
    // Navigation
    home: "Inicio",
    ourServices: "Nuestros Servicios",
    contact: "Contacto",
    
    // Home page
    heroTitle: "Soluciones Avanzadas de Pruebas Médicas",
    heroSubtitle: "Proporcionando servicios de laboratorio precisos y confiables",
    exploreServices: "Explorar Nuestros Servicios",
    
    // Services section
    servicesTitle: "Nuestros Servicios",
    coreLab: "Laboratorio Principal",
    coreLabDesc: "Pruebas completas que incluyen química, hematología, inmunología y más",
    molecularTesting: "Pruebas Moleculares",
    molecularTestingDesc: "Pruebas diagnósticas avanzadas para COVID-19, Gripe A/B y VRS",
    
    // Reagents section
    reagentsTitle: "Reactivos y Kits de Recolección",
    reagentsDesc: "Reactivos de alta calidad en los que confían investigadores, médicos y laboratorios. Diseñados para mantener la integridad durante los procesos analíticos.",
    reagentsCallToAction: "Explore cómo nuestras soluciones apoyan su flujo de trabajo con confianza.",
    
    // Expanded Reagents section for Services page
    expandedReagentsTitle: "Reactivos y Kits de Recolección",
    expandedReagentsDesc: "Las pruebas precisas comienzan con reactivos confiables, y NuWav Labs se enorgullece de apoyar ese primer paso crítico. Como distribuidor de confianza, proporcionamos una selección cuidadosa de reactivos utilizados en aplicaciones clínicas, ambientales y de investigación.",
    expandedReagentsOffers: "Ahora ofrecemos:",
    reagentsOffer1: "Reactivos para diagnóstico clínico",
    reagentsOffer2: "Reactivos de laboratorio para investigación",
    reagentsOffer3: "Soluciones para pruebas ambientales",
    reagentsOffer4: "Reactivos analíticos especializados",
    reagentsFooter: "Respaldados por nuestro compromiso con la calidad y el servicio, nuestra línea de reactivos brinda a su equipo la confianza para centrarse en los resultados, no en la logística.",
    
    // Additional Home Content
    homeContent1: "Utilizamos automatización de vanguardia y gestión rigurosa de calidad para ofrecer servicios diagnósticos y analíticos rápidos y confiables.",
    homeContent2: "Nuestros flujos de trabajo optimizados manejan todo, desde análisis de sangre rutinarios hasta pruebas moleculares complejas, garantizando precisión constante y alto rendimiento sin sacrificar la atención al detalle.",
    homeContent3: "Respaldados por un equipo de científicos experimentados y procesos de última generación, ofrecemos soluciones personalizadas para investigación, ensayos clínicos y proyectos de desarrollo. Asóciese con nosotros para obtener soporte experto, informes transparentes y tiempos de respuesta rápidos que mantienen su trabajo avanzando.",
    
    // Services Page
    servicesPageTitle: "Diagnósticos Clínicos y Moleculares Avanzados",
    servicesPageDesc: "Nuestro laboratorio clínico de alto rendimiento ofrece una amplia gama de servicios de pruebas con precisión, escalabilidad y rapidez. Utilizando sistemas sofisticados y conformes, proporcionamos diagnósticos confiables a proveedores de atención médica, grupos de investigación y organizaciones que requieren pruebas moleculares rutinarias o avanzadas.",
    coreTestingServices: "Servicios de Pruebas Básicas",
    molecularTestingServices: "Servicios de Pruebas Moleculares",
    molecularTestingDesc: "Nuestra división de diagnóstico molecular está equipada para pruebas de ácidos nucleicos de alto volumen, entregando resultados rápidos y precisos para infecciones respiratorias, incluyendo:",
    expandableCapabilities: "Capacidades Ampliables",
    expandableCapabilitiesDesc: "Gracias a la versatilidad y automatización de nuestros sistemas de laboratorio, podemos configurar rápidamente nuevos protocolos de prueba para satisfacer las necesidades específicas de su organización. Basándonos en nuestro equipo, somos capaces de expandirnos en:",
    molecularPCR: "Diagnósticos Moleculares y Basados en PCR",
    clinicalChemistry: "Química Clínica e Inmunoensayo",
    hematology: "Hematología y Análisis de Frotis Sanguíneo",
    
    // Core Testing Services Items
    generalImmunology: "Inmunología General",
    generalImmunologyDesc: "Pruebas de alergias y autoinmunidad",
    routineChemistry: "Química de Rutina",
    routineChemistryDesc: "Paneles metabólicos, renales y hepáticos completos",
    routineHematology: "Hematología de Rutina",
    routineHematologyDesc: "Recuentos de células sanguíneas, perfiles de anemia",
    urinalysis: "Análisis de Orina",
    urinalysisDesc: "Química de orina, microscopía de sedimentos",
    virology: "Virología",
    virologyDesc: "Anticuerpos virales, marcadores infecciosos comunes",
    
    // Molecular Testing Items
    covid19: "COVID-19 (SARS-CoV-2)",
    covid19Desc: "Detección rápida y precisa",
    influenza: "Influenza A/B",
    influenzaDesc: "Pruebas de gripe estacional",
    rsv: "VRS",
    rsvDesc: "Detección del virus sincitial respiratorio",
    
    // Molecular PCR Items
    multiplexRespiratory: "Paneles de patógenos respiratorios múltiples",
    gastrointestinalPathogen: "Detección de patógenos gastrointestinales",
    stiUtiTesting: "Pruebas de ITS e ITU mediante PCR en tiempo real",
    
    // Clinical Chemistry Items
    cardiacBiomarkers: "Biomarcadores cardíacos (troponina, CK-MB, BNP)",
    fertilityHormone: "Pruebas de hormonas reproductivas y fertilidad",
    vitaminPanels: "Paneles de vitamina D, tiroides y adrenales",
    infectiousSerology: "Serología de enfermedades infecciosas",
    tumorMarkers: "Marcadores tumorales e indicadores de síndrome metabólico",
    
    // Hematology Items
    cellMorphology: "Revisiones de morfología celular con tinción de alta resolución",
    differentialWBC: "Recuentos diferenciales de glóbulos blancos con marcadores",
    reticulocyte: "Análisis de reticulocitos y fracción de células inmaduras",
    hematologicDisorders: "Detección de trastornos hematológicos",
    
    whyChooseUs: "Por Qué Elegirnos",
    fullyCompliant: "Totalmente Conforme",
    fullyCompliantDesc: "Todas las operaciones se alinean con CLIA y las regulaciones federales",
    scalableThroughput: "Rendimiento Escalable",
    scalableThroughputDesc: "Pruebas de alto volumen con rápido tiempo de respuesta",
    flexibleProtocols: "Protocolos Flexibles",
    flexibleProtocolsDesc: "Desarrollo de pruebas personalizadas disponible para investigación o aplicaciones clínicas",
    partnerDriven: "Enfoque Orientado a Socios",
    partnerDrivenDesc: "Diseño colaborativo de programas de pruebas para satisfacer sus necesidades exactas",
    readyToExpand: "¿Listo para Expandir sus Pruebas?",
    readyToExpandDesc: "Si su organización está buscando un laboratorio asociado con la capacidad de escalar y adaptarse, ya sea para pruebas rutinarias o paneles especializados, estamos listos para configurar nuestros sistemas para sus objetivos.",
    
    // Contact Page
    contactUs: "Contáctenos",
    getInTouch: "Ponte en contacto con nuestro equipo",
    sendMessage: "Envíanos un mensaje",
    address: "Dirección",
    phone: "Teléfono",
    name: "Nombre",
    email: "Correo Electrónico",
    message: "Mensaje",
    submit: "Enviar",
    formSubmissionMessage: "Gracias por tu mensaje. Nos pondremos en contacto contigo pronto!",
    
    // Certifications
    certifications: "Certificaciones",
    hipaaCompliant: "Conforme a HIPAA",
    capAccredited: "Acreditado por COLA",
    cliaCertified: "Certificado por CLIA",
    privacyShield: "Conforme con Privacy Shield",
    
    // Location & Contact
    location: "Ubicación",
    
    // Legal
    legal: "Legal",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio",
    allRightsReserved: "Todos los derechos reservados.",
    
    // Privacy Policy Page
    privacyIntro: "Introducción",
    privacyIntroText: "NuWav Laboratories (\"nosotros\", \"nuestro\" o \"nos\") está comprometido a proteger su privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos su información cuando interactúa con nuestros servicios.",
    infoWeCollect: "Información que Recopilamos",
    personalHealthInfo: "Información de Salud Personal",
    personalHealthInfoText: "Como laboratorio que cumple con HIPAA, recopilamos y procesamos información de salud personal que incluye:",
    patientDemographic: "Información demográfica del paciente",
    medicalHistory: "Historial médico y condiciones",
    labResults: "Resultados de pruebas de laboratorio",
    insuranceInfo: "Información de seguro y facturación",
    otherHealthInfo: "Otra información relacionada con la salud necesaria para servicios de pruebas",
    howWeUseInfo: "Cómo Usamos Su Información",
    useInfoText: "Usamos la información recopilada para:",
    providingLabServices: "Proporcionar servicios de pruebas de laboratorio",
    processingResults: "Procesar y entregar resultados de pruebas",
    billingPayment: "Facturación y procesamiento de pagos",
    communicatingTests: "Comunicación sobre sus pruebas y resultados",
    qualityAssurance: "Garantía y mejora de calidad",
    complianceRequirements: "Cumplimiento con requisitos legales y regulatorios",
    dataProtection: "Protección de Datos",
    dataProtectionText: "Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información, incluyendo:",
    encryption: "Cifrado de datos en tránsito y en reposo",
    accessControls: "Controles de acceso y medidas de autenticación",
    securityAssessments: "Evaluaciones y auditorías de seguridad regulares",
    staffTraining: "Capacitación del personal sobre procedimientos de privacidad y seguridad",
    physicalSecurity: "Medidas de seguridad física en nuestras instalaciones",
    hipaaCompliance: "Cumplimiento con HIPAA",
    hipaaComplianceText: "Como entidad cubierta bajo HIPAA, mantenemos el cumplimiento con todos los requisitos aplicables, incluyendo:",
    maintainingPrivacy: "Mantener la privacidad de la información de salud protegida",
    providingAccess: "Proporcionar acceso a su información de salud bajo petición",
    obtainingAuth: "Obtener autorizaciones apropiadas para la divulgación",
    accountingDisclosures: "Mantener un registro de divulgaciones",
    privacyPractices: "Proporcionar aviso de prácticas de privacidad",
    yourRights: "Sus Derechos",
    yourRightsText: "Bajo HIPAA y otras leyes aplicables, usted tiene ciertos derechos con respecto a su información de salud:",
    rightToAccess: "Derecho a acceder a su información de salud",
    rightToCorrections: "Derecho a solicitar correcciones a su información",
    rightToAccounting: "Derecho a recibir un registro de divulgaciones",
    rightToRestrictions: "Derecho a solicitar restricciones sobre uso y divulgación",
    rightToConfidential: "Derecho a recibir comunicaciones confidenciales",
    rightToNotice: "Derecho a recibir aviso de prácticas de privacidad",
    contactInfo: "Información de Contacto",
    contactInfoText: "Para preguntas sobre esta Política de Privacidad o para ejercer sus derechos, contacte a nuestro Oficial de Privacidad en nuestra oficina:",
    updatesToPolicy: "Actualizaciones a Esta Política",
    updatesToPolicyText: "Podemos actualizar esta Política de Privacidad de vez en cuando. La versión actualizada será indicada por una fecha de \"Última Actualización\" actualizada y la versión actualizada será efectiva tan pronto como sea accesible.",
    lastUpdated: "Última Actualización: 16 de abril de 2025",
    
    // Terms of Service Page
    agreementToTerms: "Acuerdo con los Términos",
    agreementToTermsText: "Estos Términos de Servicio constituyen un acuerdo legalmente vinculante entre usted y NuWav Laboratories (\"nosotros\", \"nos\" o \"nuestro\") en relación con su uso de nuestros servicios de laboratorio y sitio web.",
    servicesDescription: "Descripción de Servicios",
    servicesDescriptionText: "NuWav Laboratories proporciona servicios de pruebas de laboratorio clínico, incluyendo pero no limitado a:",
    coreLabTesting: "Servicios de pruebas de laboratorio central",
    molecularDiagnostic: "Pruebas de diagnóstico molecular",
    clinicalChemistryAnalysis: "Análisis de química clínica",
    diagnosticProcedures: "Procedimientos diagnósticos de laboratorio",
    resultsReporting: "Reporte e interpretación de resultados",
    professionalStandards: "Estándares Profesionales",
    professionalStandardsText: "Mantenemos los más altos estándares profesionales y cumplimos con todas las regulaciones aplicables, incluyendo:",
    hipaaComplianceStandard: "Cumplimiento con HIPAA para privacidad del paciente",
    capAccreditationStandards: "Estándares de acreditación CAP",
    cliaCertificationRequirements: "Requisitos de certificación CLIA",
    privacyShieldFramework: "Principios del marco Privacy Shield",
    stateRegulations: "Regulaciones estatales y federales de laboratorio",
    userResponsibilities: "Responsabilidades del Usuario",
    userResponsibilitiesText: "Al usar nuestros servicios, usted acepta:",
    provideAccurateInfo: "Proporcionar información precisa y completa",
    maintainConfidentiality: "Mantener la confidencialidad de cualquier credencial de cuenta",
    complyWithLaws: "Cumplir con todas las leyes y regulaciones aplicables",
    useLegitimateServices: "Usar servicios solo para propósitos médicos legítimos",
    respectIntellectualProperty: "Respetar los derechos de propiedad intelectual",
    sampleRequirements: "Requisitos de Muestra",
    sampleRequirementsText: "Todas las muestras enviadas deben:",
    meetCollectionRequirements: "Cumplir con requisitos de recolección especificados",
    properlyLabeled: "Estar correctamente etiquetadas e identificadas",
    properlyPackaged: "Estar empacadas según las pautas de seguridad",
    includeRequisition: "Incluir información completa de requisición",
    submitTimeframes: "Ser enviadas dentro de los plazos aceptables",
    resultsAndReports: "Resultados e Informes",
    resultsAndReportsText: "Con respecto a los resultados de pruebas e informes:",
    resultsProvidedTo: "Los resultados se proporcionan solo a destinatarios autorizados",
    turnaroundTimes: "Los tiempos de respuesta son estimaciones y no garantías",
    criticalValues: "Los valores críticos se reportan según el protocolo",
    resultsRequireCorrelation: "Los resultados pueden requerir correlación clínica",
    reportsRetention: "Los informes se mantienen de acuerdo con las políticas de retención",
    limitationOfLiability: "Limitación de Responsabilidad",
    limitationOfLiabilityText: "En la máxima medida permitida por la ley, NuWav Laboratories no será responsable por:",
    indirectDamages: "Daños indirectos o consecuentes",
    serviceDelays: "Retrasos en la prestación del servicio",
    improperSampleCollection: "Problemas derivados de la recolección inadecuada de muestras",
    thirdPartyInterpretation: "Interpretación de resultados por terceros",
    beyondControl: "Circunstancias fuera del control razonable",
    changesToTerms: "Cambios a los Términos",
    changesToTermsText: "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos inmediatamente después de publicarse en nuestro sitio web. El uso continuado de nuestros servicios constituye la aceptación de los términos modificados."
  }
};

export default translations; 